<template>
  <div class="swiper-container">
    <swiper
      class="swiper-wrapper"
      :options="swiperOption"
      ref="mySwiper"
    >
      <!-- slides -->
      <swiper-slide class="swiper-slide">
        <div class="slider-image">
          <img src="../../../assets/picture/screen-2.png" alt="" />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="slider-image">
          <img src="../../../assets/picture/screen-3.png" alt="" />
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
// require styles
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "IndexSwiper",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
        },
        speed: 1000,
        effect: "coverflow",
        loop: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 80,
          depth: 200,
          modifier: 1,
          slideShadows: false,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    this.swiper.slideTo(2, 1000, false);
  },
};
</script>

<style scoped>
</style>
